module.exports = __webpack_public_path__ + "img/bell.fe24a150.svg";